// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"1623fc3a","787":"325cd123"}[chunkId] + ".chunk.js";
};